/*
  Appstle Bundles (Fixed Pricing): ausgeblendete Pflicht-Artikel (Daily Bottle, Min/Max 1)
  aus dem Zähler herausrechnen, damit dort z. B. "2 / 4" statt "3 / 5" steht.
*/
(function () {
  var HIDDEN_ROW = /bottle/i;

  var fix = function (root) {
    var contents = root.querySelector('.ab-fixed-pricing-bundle-contents');
    var current = root.querySelector('.ab-fixed-pricing-bundle-contents-counter-current');
    var target = root.querySelector('.ab-fixed-pricing-bundle-contents-counter-target');
    if (!contents || !current || !target) return;

    var hidden = 0;
    var hiddenRows = 0;
    root.querySelectorAll('.ab-fixed-pricing-child-row').forEach(function (row) {
      var img = row.querySelector('img');
      if (!img || !HIDDEN_ROW.test(img.alt || '')) return;
      hiddenRows += 1;
      var value = row.querySelector('.ab-fixed-pricing-stepper-value');
      if (value) {
        hidden += parseInt(value.textContent, 10) || 0;
        return;
      }
      // Ausgeblendeter Pflicht-Artikel noch nicht gewählt -> automatisch 1x hinzufügen
      var add = row.querySelector('.ab-fixed-pricing-child-row-add-button');
      if (add && !row.dataset.dailyAutoAdded) {
        row.dataset.dailyAutoAdded = 'true';
        add.click();
      }
    });

    // Appstle-Texte nicht anfassen (React), sondern eigenen Zähler daneben pflegen
    var rawCurrent = parseInt(current.textContent, 10);
    var rawTarget = parseInt(target.textContent.replace(/[^0-9]/g, ''), 10);
    if (isNaN(rawCurrent) || isNaN(rawTarget)) return;

    var counter = current.parentElement;
    var own = counter.parentElement.querySelector('.daily-ab-counter');
    if (!own) {
      own = document.createElement('div');
      own.className = 'daily-ab-counter';
      counter.insertAdjacentElement('afterend', own);
    }
    var text = Math.max(0, rawCurrent - hidden) + ' / ' + Math.max(0, rawTarget - hiddenRows);
    if (own.textContent !== text) own.textContent = text;
    var complete = rawCurrent >= rawTarget ? 'true' : 'false';
    if (contents.dataset.dailyComplete !== complete) contents.dataset.dailyComplete = complete;
  };

  // Appstle baut das Widget z. B. beim Variantenwechsel komplett neu auf -> ganze Seite beobachten
  var queued = false;
  var run = function () {
    queued = false;
    document.querySelectorAll('#appstle-bundle, .appstle-bundle').forEach(fix);
  };
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    Promise.resolve().then(run);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  run();

  // Klick auf Name/Bild einer Sorte öffnet statt des Appstle-Popups die Produktseite
  var handleForRow = function (row) {
    var img = row.querySelector('img');
    var src = img && img.getAttribute('src');
    if (!src || !window._ABConfig) return null;
    var file = src.split('?')[0].split('/').pop();
    var config = JSON.stringify(window._ABConfig).replace(/\\/g, '');
    var re = /"imageSrc":"([^"]*)","productHandle":"([^"]+)"/g;
    var match;
    while ((match = re.exec(config))) {
      if (match[1].split('?')[0].split('/').pop() === file) return match[2];
    }
    return null;
  };

  document.addEventListener('click', function (event) {
    var target = event.target.closest('.ab-fixed-pricing-child-row-title, .ab-fixed-pricing-child-row-image-wrapper');
    if (!target) return;
    var row = target.closest('.ab-fixed-pricing-child-row');
    var handle = row && handleForRow(row);
    if (!handle) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle;
  }, true);

  // Geschmack unter dem Sortennamen (aus Produkt-Tag "geschmack:peach-blood-orange")
  var tastes = {};
  var tasteFor = function (handle) {
    if (!tastes[handle]) {
      tastes[handle] = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var tag = p && (p.tags || []).filter(function (t) { return /^geschmack:/i.test(t); })[0];
          if (!tag) return '';
          return tag.split(':')[1].split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
        })
        .catch(function () { return ''; });
    }
    return tastes[handle];
  };

  var addTastes = function () {
    document.querySelectorAll('#appstle-bundle .ab-fixed-pricing-child-row').forEach(function (row) {
      var title = row.querySelector('.ab-fixed-pricing-child-row-title');
      if (!title || title.parentElement.querySelector('.daily-ab-taste')) return;
      var handle = handleForRow(row);
      if (!handle) return;
      tasteFor(handle).then(function (taste) {
        if (!taste || !title.isConnected || title.parentElement.querySelector('.daily-ab-taste')) return;
        var el = document.createElement('div');
        el.className = 'daily-ab-taste';
        el.textContent = taste;
        var headline = title.parentElement.querySelector('.daily-ab-headline');
        (headline || title).insertAdjacentElement('afterend', el);
      });
    });
  };
  // Überschrift je Sorte (z. B. „Etwas Gutes für Deine Verdauung“) zwischen Name und Geschmack.
  // Quelle ist die Sorten-Liste derselben Seite (Section floow-routine: Label = Sortenname,
  // Titel = Überschrift), damit die Texte nur an einer Stelle im Theme-Editor gepflegt werden.
  // Mit Überschrift wird der Appstle-Name per CSS zum kleinen Label (appstle-bundle.css).
  var headlines = null;
  var headlineFor = function (name) {
    if (!headlines) {
      headlines = {};
      document.querySelectorAll(".floow-routine__item").forEach(function (item) {
        var tag = item.querySelector(".floow-routine__tag");
        var title = item.querySelector(".floow-routine__title");
        if (tag && title) headlines[tag.textContent.trim().toLowerCase()] = title.textContent.trim();
      });
    }
    return headlines[String(name || "").trim().toLowerCase()] || "";
  };

  var addHeadlines = function () {
    document.querySelectorAll("#appstle-bundle .ab-fixed-pricing-child-row").forEach(function (row) {
      var title = row.querySelector(".ab-fixed-pricing-child-row-title");
      if (!title) return;
      var text = headlineFor(title.textContent);
      var el = title.parentElement.querySelector(".daily-ab-headline");
      if (!text) {
        if (el) el.remove();
        return;
      }
      if (!el) {
        el = document.createElement("div");
        el.className = "daily-ab-headline";
      }
      if (el.previousElementSibling !== title) title.insertAdjacentElement("afterend", el);
      if (el.textContent !== text) el.textContent = text;
    });
  };

  var tasteQueued = false;
  new MutationObserver(function () {
    if (tasteQueued) return;
    tasteQueued = true;
    setTimeout(function () { tasteQueued = false; addHeadlines(); addTastes(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
  addHeadlines();
  addTastes();
})();
